import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=d2fedba0&scoped=true"
import script from "./topTitle.vue?vue&type=script&lang=js"
export * from "./topTitle.vue?vue&type=script&lang=js"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=d2fedba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fedba0",
  null
  
)

export default component.exports